import React, { useState } from "react";
import { BsCheckCircleFill } from "react-icons/bs";

const BuyerAgentAccordion = ({
  userRole,
  setBuyerAgent,
  setAccordionState,
  accordionState,
}) => {
  const [formState, setFormState] = useState({
    value: "",
    error: "",
  });

  const QUESTIONS = {
    BUYER: "Are you represented by an Agent?",
    AGENT: "Are you buying this property for yourself?",
  };

  const validateSelection = () => {
    if (!formState.value) {
      setFormState((prev) => ({ ...prev, error: "Please select one option" }));
      return false;
    }
    return true;
  };

  const determineIsBuyerAgent = (value) => {
    return (
      (userRole === "Buyer" && value === "Yes") ||
      (userRole !== "Buyer" && value === "No")
    );
  };

  const handleChange = (e) => {
    const { value } = e.target;

    setFormState((prev) => ({
      value: value,
      error: "",
    }));

    const isBuyerAgent = determineIsBuyerAgent(value);
    setBuyerAgent(isBuyerAgent);
  };

  const handleContinue = () => {
    if (validateSelection()) {
      setAccordionState({
        ...accordionState,
        accordion1: {
          ...accordionState.accordion1,
          close: true,
          visited: true,
          edit: true,
        },
        accordion2: { close: false, disable: false, edit: false },
      });
    }
  };

  const renderQuestion = () => (
    <p className="buyer-questio  pt-2 mr10">
      {userRole === "Buyer" ? QUESTIONS.BUYER : QUESTIONS.AGENT}
    </p>
  );

  const renderSelect = () => (
    <div className="form-group mb-3 fs-12">
      <select
        className="form-select fs-12"
        value={formState.value}
        onChange={handleChange}
      >
        <option value="" className="select-color-buyer">Select</option>
        <option value="Yes">Yes</option>
        <option value="No">No</option>
      </select>
      { formState.error && (
      <p className="error-message text-danger mt-1">{formState.error}</p>
    )}
    </div>
  );


  return (
    <div className="accordion-item mb-2 border rounded">
      <h2 className="accordion-header p-1" id="flush-headingOne">
        <div
          className={`accordion-button ${
            accordionState?.accordion1?.close ? "collapsed" : ""
          }  ${
            accordionState?.accordion1?.close &&
            accordionState?.accordion1?.visited
              ? "no-caret"
              : ""
          }`}
          // type="button"
          // data-bs-toggle="collapse"
          // data-bs-target="#flush-collapseOne"
          // aria-expanded="true"
          // aria-controls="flush-collapseOne"
        >
          <div className="d-flex justify-content-between w-100">
            <p className="mb-0 responsive-heading">
              {accordionState?.accordion1?.visited ? (
                <BsCheckCircleFill className="icon_bid me-2" size={30} />
              ) : (
                <BsCheckCircleFill className="text-dark me-2" size={30} />
              )}
              Buyer / Agent Information
            </p>
            {accordionState?.accordion1?.edit && (
              <>
                <div>
                  <span
                    className="fa fa-pencil cursor-pointer"
                    onClick={() =>
                      setAccordionState({
                        ...accordionState,
                        accordion1: {
                          ...accordionState.accordion1,
                          edit: false,
                          close: false,
                          visited: false,
                        },
                        accordion2: {
                          ...accordionState.accordion2,
                          close: true,
                          visited: false,
                          edit:false
                        },
                          accordion3: {
                          ...accordionState.accordion3,
                          close: true,
                          visited: false,
                          edit:false
                        },
                          accordion4: {
                          ...accordionState.accordion4,
                          close: true,
                          visited: false,
                          edit:false
                        },
                      })
                    }
                  ></span>
                </div>
              </>
            )}
          </div>
        </div>
      </h2>
      <div
        id="flush-collapseOne"
        className={`accordion-collapse collapse ${
          accordionState?.accordion1?.close ? "" : "show"
        }`}
        aria-labelledby="flush-headingOne"
        data-bs-parent="#accordionFlushExample"
      >
        <div className="accordion-body pl35 mobile-padding-0-offer">
          <div className="buyer-or-agent ">
            {renderQuestion()}
            {renderSelect()}
          </div>
          
          <button
            className="continue-button btn btn-primary"
            onClick={handleContinue}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default BuyerAgentAccordion;
